import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/rexue', label: '热血' },
    { to: '/category/aiqing', label: '爱情' },
    { to: '/category/qihuan', label: '奇幻' },
    { to: '/category/danmei', label: '耽美' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="text-2xl font-heading font-black text-primary-500 tracking-tight whitespace-nowrap">
            韩漫网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                location.pathname === link.to
                  ? 'bg-primary-500 text-background-950'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/50 text-foreground-300 hover:text-foreground-50 hover:bg-background-300/50 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <button
          type="button"
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 cursor-pointer"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/30'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}